import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@material-ui/core';

// project imports
import config from '../../../configs';
import Logo from './../../../ui-component/Logo';

//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSection = () => {
    return (
        <ButtonBase disableRipple component={Link} to={config.dashboardPath}>
            {/* Sidebar row is 260px wide (see store/constant.js's drawerWidth) minus 16+12px
                padding -- the full wordmark's ~4.3:1 aspect ratio needs a shorter height than
                the auth-page default to fit without overflowing that row. */}
            <Logo height={50} />
        </ButtonBase>
    );
};

export default LogoSection;
